(function(){
  var map={
    'Jumpboard':{
      quartz:'https://cdn.shopify.com/s/files/1/0836/7344/8668/files/jumpboard.webp?v=1790801488',
      obsidian:'https://cdn.shopify.com/s/files/1/0836/7344/8668/files/78d0cb20-2e1e-4272-a201-12e0d6c780af.webp?v=1790837579'
    },
    'Sitting box':{
      quartz:'https://cdn.shopify.com/s/files/1/0836/7344/8668/files/sitting-box.webp?v=1790801488',
      obsidian:'https://cdn.shopify.com/s/files/1/0836/7344/8668/files/download_17.webp?v=1790807758'
    },
    'Platform extender':{
      quartz:'https://cdn.shopify.com/s/files/1/0836/7344/8668/files/platform-extender.webp?v=1790801488',
      obsidian:'https://cdn.shopify.com/s/files/1/0836/7344/8668/files/download_18.webp?v=1790807759'
    }
  };
  function swap(c){
    var k=c.toLowerCase().trim();
    if(k!=='quartz'&&k!=='obsidian')return;
    var sec=document.querySelector('.wl-inc');
    if(!sec)return;
    sec.querySelectorAll('img[alt]').forEach(function(img){
      var alt=img.getAttribute('alt');
      if(map[alt]&&map[alt][k])img.src=map[alt][k];
    });
  }
  function checkActive(){
    var el=document.querySelector('.wl-swatch.is-active[data-value]');
    if(!el)return;
    var v=(el.getAttribute('data-value')||'').toLowerCase();
    swap(v);
  }
  function initObserver(){
    var swatches=document.querySelectorAll('.wl-swatch[data-value]');
    if(!swatches.length)return false;
    var obs=new MutationObserver(checkActive);
    swatches.forEach(function(s){obs.observe(s,{attributes:true,attributeFilter:['class']});});
    checkActive();
    return true;
  }
  if(!initObserver()){
    document.addEventListener('DOMContentLoaded',initObserver);
    window.addEventListener('load',initObserver);
  }
  document.addEventListener('click',function(e){
    var el=e.target.closest('[data-value],[data-option-value]');
    if(!el)return;
    var v=(el.getAttribute('data-value')||el.getAttribute('data-option-value')||'').toLowerCase();
    if(v==='obsidian'||v==='quartz')setTimeout(function(){swap(v);},60);
  });
  function checkUrl(){
    var p=new URLSearchParams(window.location.search);
    var v=p.get('variant');
    if(v==='51084711985372')swap('obsidian');
    else if(v==='51084711952604')swap('quartz');
  }
  checkUrl();
  var oP=history.pushState;history.pushState=function(){oP.apply(this,arguments);checkUrl();};
  var oR=history.replaceState;history.replaceState=function(){oR.apply(this,arguments);checkUrl();};
  window.addEventListener('popstate',checkUrl);

  function injectComparisonImages(){
    var studio=document.querySelector('.sv-hd-studio');
    if(studio&&!studio.querySelector('img')){
      var img=document.createElement('img');
      img.src='https://cdn.shopify.com/s/files/1/0836/7344/8668/files/studio-pilates-comparison.jpg?v=1790825829';
      img.alt='Pilates studio';
      img.loading='lazy';
      studio.appendChild(img);
    }
    var terra=document.querySelector('.sv-hd-terra');
    if(terra&&!terra.querySelector('img')){
      var img2=document.createElement('img');
      img2.src='https://cdn.shopify.com/s/files/1/0836/7344/8668/files/terrasol-folded-comparison.png?v=1790825829';
      img2.alt='TerraSol folded';
      img2.loading='lazy';
      terra.appendChild(img2);
    }
  }

  function injectProgramImage(){
    var ph=document.querySelector('.pg-screen-ph');
    if(ph){
      var img=document.createElement('img');
      img.src=window.innerWidth<=760
        ?'https://cdn.shopify.com/s/files/1/0836/7344/8668/files/warrior-pose-mobile.webp?v=1790867583'
        :'https://cdn.shopify.com/s/files/1/0836/7344/8668/files/program-pilates-session.webp?v=1790828349';
      img.alt='Woman doing Pilates on reformer';
      img.loading='lazy';
      ph.parentNode.insertBefore(img,ph);
      ph.parentNode.removeChild(ph);
    }
    var fine=document.querySelector('.pg-fine');
    if(fine)fine.style.display='none';
    var pgBox=document.querySelector('.pg-box');
    if(pgBox){
      var bot=pgBox.querySelector('.pg-bottom');
      if(bot)bot.style.gap='8px';
    }
    if(window.innerWidth<=760){
      var s=document.createElement('style');
      s.textContent='.pg-hud{padding:6px 10px!important;gap:4px!important}.pg-hud b{font-size:12px!important}.pg-hud small{font-size:9px!important}';
      document.head.appendChild(s);
    }
  }

  function injectSetupVideo(){
    var grid=document.querySelector('.sw-grid');
    if(!grid)return;
    var vid=grid.querySelector('.sw-vid');
    var inner=grid.querySelector('.sw-vid-inner');
    if(!vid||!inner||inner.querySelector('video'))return;

    var stepsEl=grid.querySelector('.sw-steps');
    if(stepsEl){
      stepsEl.style.borderTop='none';
      stepsEl.querySelectorAll('li').forEach(function(li){li.style.borderBottom='none';});
    }

    if(window.innerWidth<=860){
      grid.style.gridTemplateColumns='1fr';
      grid.style.maxWidth='640px';
      grid.style.margin='0 auto';

      var textCol=grid.children[1];
      if(!textCol)return;
      var h2=textCol.querySelector('.sw-h');
      var sub=textCol.querySelector('.sw-sub');
      var steps=textCol.querySelector('.sw-steps');
      if(!h2||!steps)return;

      var topDiv=document.createElement('div');
      topDiv.style.textAlign='center';
      topDiv.appendChild(h2);
      if(sub)topDiv.appendChild(sub);

      grid.innerHTML='';
      grid.appendChild(topDiv);
      vid.style.justifySelf='center';
      vid.style.order='0';
      grid.appendChild(vid);
      grid.appendChild(steps);
    }

    var poster=document.createElement('img');
    poster.src='https://cdn.shopify.com/s/files/1/0836/7344/8668/files/setup-poster.webp?v=1790829917';
    poster.alt='TerraSol setup demonstration';
    poster.style.cssText='position:absolute;inset:0;width:100%;height:100%;object-fit:cover;border-radius:14px';
    inner.textContent='';
    inner.style.position='relative';
    inner.appendChild(poster);

    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting){
            var video=document.createElement('video');
            video.src='https://cdn.shopify.com/videos/c/vp/ffb233dcc09348b3993fe9b95dd72be7/ffb233dcc09348b3993fe9b95dd72be7.HD-720p-1.6Mbps-96081614.mp4';
            video.poster='https://cdn.shopify.com/s/files/1/0836/7344/8668/files/setup-poster.webp?v=1790829917';
            video.muted=true;
            video.loop=true;
            video.playsInline=true;
            video.autoplay=true;
            video.setAttribute('playsinline','');
            video.setAttribute('webkit-playsinline','');
            video.style.cssText='position:absolute;inset:0;width:100%;height:100%;object-fit:cover;border-radius:14px';
            video.addEventListener('loadeddata',function(){
              if(poster.parentNode)poster.parentNode.removeChild(poster);
            });
            inner.appendChild(video);
            video.play().catch(function(){});
            io.disconnect();
          }
        });
      },{rootMargin:'300px'});
      io.observe(vid);
    }
  }

  function styleShopPay(){
    document.querySelectorAll('.wl-faq__a').forEach(function(el){
      el.innerHTML=el.innerHTML.replace(/Shop Pay/g,'<span style="color:#5a31f4;font-weight:600">Shop Pay</span>');
    });
  }

  function updateColors(){
    var s=document.createElement('style');
    s.textContent=':root,.color-scheme-1,.color-scheme-2,.color-scheme-3,.color-scheme-4,.color-scheme-5{--color-primary-button-background:#538125!important;--color-primary-button-border:#538125!important;--color-primary-button-hover-background:#42671E!important;--color-primary-button-hover-border:#42671E!important}'
      +'.wl-hero__btn,.wl-nl__form button,.wl-bb__atc,.wl-pf__save,.wl-bb__save{background-color:#538125!important;border-color:#538125!important}'
      +'.wl-bb__save{background:#538125!important}'
      +'.wl-inc-pill{background:#538125!important}'
      +'.wl-sticky__btn{background:#538125!important;border-color:#538125!important}';
    document.head.appendChild(s);
  }

  function fixSpacing(){
    var inc=document.querySelector('.wl-inc');
    if(inc)inc.style.marginTop='20px';
    var csH=document.querySelector('.cs-h');
    if(csH)csH.style.marginBottom='40px';
    var svSec=document.querySelector('.sv-sec');
    if(svSec)svSec.style.background='#E6EBE1';
    var tlH=document.querySelector('.wl-stl__h');
    if(tlH)tlH.style.marginTop='20px';

    var stickyBtn=document.querySelector('.wl-sticky__btn');
    if(stickyBtn){
      stickyBtn.style.padding='10px 22px';
      stickyBtn.style.justifyContent='center';
    }

    document.querySelectorAll('.sw-steps .sw-n').forEach(function(el){
      var txt=el.textContent.trim();
      el.textContent='';
      var sp=document.createElement('span');
      sp.textContent=txt;
      sp.style.cssText='display:block;transform:translateY(-2px)';
      el.appendChild(sp);
    });
  }

  function setupInfiniteScroll(){
    var track=document.querySelector('.cs-track');
    var row=track&&track.querySelector('.cs-row');
    if(!track||!row)return;
    var cards=Array.from(row.querySelectorAll('.cs-card'));
    var n=cards.length;
    if(n<2)return;
    row.style.padding='0';
    row.style.position='relative';
    track.style.overflowAnchor='none';
    for(var i=n-1;i>=0;i--)row.insertBefore(cards[i].cloneNode(true),row.firstChild);
    cards.forEach(function(c){row.appendChild(c.cloneNode(true));});
    var allCards=Array.from(row.children);
    void row.offsetWidth;
    var setWidth=allCards[n].offsetLeft-allCards[0].offsetLeft;
    track.style.scrollSnapType='none';
    track.scrollLeft=allCards[n].offsetLeft;
    requestAnimationFrame(function(){track.style.scrollSnapType='x mandatory';});
    var jumping=false,timer=null;
    function onScrollSettled(){
      if(jumping)return;
      var sl=track.scrollLeft;
      var best=0,bestDist=Infinity;
      for(var i=0;i<allCards.length;i++){
        var d=Math.abs(allCards[i].offsetLeft-sl);
        if(d<bestDist){bestDist=d;best=i;}
      }
      if(best<n){
        jumping=true;
        track.style.scrollSnapType='none';
        track.scrollLeft=sl+setWidth;
        requestAnimationFrame(function(){track.style.scrollSnapType='x mandatory';jumping=false;});
      }else if(best>=2*n){
        jumping=true;
        track.style.scrollSnapType='none';
        track.scrollLeft=sl-setWidth;
        requestAnimationFrame(function(){track.style.scrollSnapType='x mandatory';jumping=false;});
      }
    }
    track.addEventListener('scroll',function(){
      if(jumping)return;
      clearTimeout(timer);
      timer=setTimeout(onScrollSettled,150);
    });
  }

  function injectStickyGuard(){
    var s=document.createElement('style');
    s.textContent='@media(max-width:989px){.wl-g{position:static!important;top:auto!important}}';
    document.head.appendChild(s);
  }

  function setupStickyLayout(){
    injectStickyGuard();
    if(window.innerWidth<=989)return;
    var gallery=document.querySelector('.wl-g');
    var buyBox=document.querySelector('.wl-bb');
    var inc=document.querySelector('.wl-inc');
    if(!gallery||!buyBox||!inc)return;
    var incWrapper=inc.closest('.shopify-section');
    buyBox.appendChild(inc);
    if(incWrapper)incWrapper.style.display='none';
    gallery.style.position='sticky';
    gallery.style.top='20px';
    var wrap=gallery.closest('.wl-pdp__wrap');
    if(wrap)wrap.style.paddingBottom='40px';
  }

  function injectAll(){
    updateColors();
    injectComparisonImages();
    injectProgramImage();
    injectSetupVideo();
    styleShopPay();
    fixSpacing();
    setupStickyLayout();
    setupInfiniteScroll();
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',injectAll);
  }else{
    injectAll();
  }
})();
